import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { RouterProvider } from "react-router"
import { AppProviders } from "~/app/AppProviders"
import { createRouter } from "~/app/routes"
import "~/shared/theme/global.css"

const container = document.getElementById("root")

if (!container) {
  throw new Error("Missing #root element")
}

createRoot(container).render(
  <StrictMode>
    <AppProviders ownsDocument>
      <RouterProvider router={createRouter()} />
    </AppProviders>
  </StrictMode>,
)
